import axios from '@/utils/http';

export default (order, lang = 'en') => {
  const langObj = {
    'zh-cn': 'zh-CN',
    en: 'en',
  };
  lang = langObj[lang] || 'en';
  return axios
    .get(`/multisig_order/${order}`, {
      params: {
        lang,
      },
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
